<template>
    <div class="login-container">
        <nuxt-link :to="localePath('/')">
            <div class="logo-img"></div>
        </nuxt-link>

        <div class="main-wrapper">
            <div class="main-img"></div>
            <h1>{{ $t('activate-account2') }}</h1>
            <div class="subtitle-txt">{{ $t('activate-account3') }}</div>
            <div class="subtitle-txt2">{{ $t('activate-account4') }}</div>
            <div class="btn-bid-cancel" v-on:click="resendMail">{{ $t('activate-account5') }}</div>
        </div>

        <div class="loading" v-if="isLoading">
            <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                <path d="M0 24C0 19.2532 1.40757 14.6131 4.04473 10.6663C6.68188 6.71954 10.4302 3.64339 14.8156 1.82689C19.201 0.0103874 24.0266 -0.464893 28.6822 0.461155C33.3377 1.3872 37.6141 3.67298 40.9706 7.02944C44.327 10.3859 46.6128 14.6623 47.5388 19.3178C48.4649 23.9734 47.9896 28.799 46.1731 33.1844C44.3566 37.5698 41.2805 41.3181 37.3337 43.9553C33.3869 46.5924 28.7468 48 24 48V43.9992C27.9555 43.9992 31.8221 42.8263 35.111 40.6287C38.3998 38.4312 40.9632 35.3077 42.4769 31.6534C43.9905 27.999 44.3866 23.9778 43.6149 20.0984C42.8432 16.2189 40.9385 12.6554 38.1416 9.85843C35.3446 7.06149 31.7811 5.15675 27.9016 4.38508C24.0222 3.61341 20.001 4.00946 16.3466 5.52315C12.6923 7.03684 9.56881 9.60019 7.37127 12.889C5.17373 16.1779 4.0008 20.0445 4.0008 24H0Z" fill="#004F7F"/>
            </svg>
        </div>
    </div>
</template>

<script>

import {mapActions} from "vuex";
import {AAuth} from "@/store/actions";

export default {
    name: 'RegPending',
    head: {
        title: 'Registration pending activation | Fine Wine Trading App',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
            }
        ],
        bodyAttrs: {
            class: 'page-reg-success'
        }
    },
    props: {
        navigation: {
            type: Object
        }
    },
    data() {
        return {
            isLoading: false
        }
    },
    methods: {
        ...mapActions({
            sendMail: AAuth.SEND_MAIL
        }),
        resendMail() {
            this.isLoading = true
            this.sendMail(localStorage.getItem('user_email')).then(() => {
                this.isLoading = false
            })
        }
    }
}
</script>

<style scoped>
.login-container {
    text-align: center;
    padding: 0 calc(3 * var(--gutter)) calc(4 * var(--gutter));
    align-items: center;
    display: flex;
    flex-direction: column;
}

.logo-img {
    background: url('../assets/v_dark.svg') no-repeat center 50px;
    background-size: contain;
    width: 300px;
    height: 180px;
    margin: 0 auto;
}
.main-wrapper {
    width: 100%;
    height: 343px;
    max-width: 560px;
    padding: 24px 40px;
    flex-direction: column;
    align-items: center;
    display: flex;
    border-radius: 8px;
    background: #F6F7FA;
    margin-top: 64px;
}
.main-img {
    width: 120px;
    height: 120px;
    background: url('../assets/email-sent.gif') no-repeat center;
    background-size: contain;
}
.main-wrapper h1 {
    font-family: 'Montserrat', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: normal;
    text-align: center;
    color: black;
    margin-top: 16px;
    margin-bottom: 4px;
}
.subtitle-txt {
    font-family: 'Montserrat', sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    color: rgba(0, 0, 0, 0.88);
    margin-bottom: 40px;

}
.subtitle-txt2 {
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: rgba(0, 0, 0, 0.38);
    margin-bottom: 16px;
}
.btn-bid-cancel {
    border-radius: 8px;
    border: 1px solid #004F7F;
    padding: 8px 16px;
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    color: #004F7F;
    text-decoration: none;
    background: transparent;
}
.btn-bid-cancel:hover {
    cursor: pointer;
}
.loading {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    text-align: center;
    background: rgba(0, 0, 0, 0.4);
}

.loading svg {
    top: 50%;
    position: relative;
}

@media (max-width: 767px) {
    .login-container {
        padding: 16px;
    }
}
</style>

<style>
.page-reg-success .header-toolbar-not-logged,
.page-reg-success .main-footer {
    display: none;
}
.page-reg-success .v-main {
    padding-top: 0 !important;
}
</style>
